<template>
  <div>
    <div class="wrapper wrapper-content  animated fadeInRight" v-if="tag">
      <div class="col-md-12">
        <div class="col-md-3"><h2><a :href="'https://' + tag.domain" target="_blank">{{ tag.decodedDomain }}</a></h2></div>
        <div class="col-md-3">
          <table class="table small m-b-xs">
            <tbody>
            <tr>
              <td>Client</td>
              <td>
                <e-txt
                  type="select"
                  :options="f.clients"
                  select-label="name"
                  select-value="id"
                  :selected-value="tag.client ? tag.client.id : null"
                  :text="tag.client ? tag.client.name : '/'"
                  close-on-save="true"
                  @input="updateProperty($event, 'client')"
                ></e-txt>
              </td>
            </tr>
            <tr>
              <td>Links</td>
              <td>{{ tag.siteCount }}</td>
            </tr>
            <tr>
              <td>Tags</td>
              <td>
                <v-select
                  :options="tags"
                  multiple="multiple"
                  :value="tag.tags"
                  @input="updateProperty($event.join(','), 'tags')"
                ></v-select>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-6">
          Some moar stats
        </div>
      </div>
      <div class="ibox">
        <div class="ibox-content">
          <table class="table table-hover">
            <thead>
            <tr>
              <th></th>
              <th>Domain</th>
              <th>Client</th>
              <th>Group</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(site, i) in linkSites" :key="site.id">
              <td>{{ i + 1 }}</td>
              <td><router-link :to="'/pbn/' + site.punyDomain">{{ site.domain }}</router-link></td>
              <td>{{ site.client ? site.client.name : '/' }}</td>
              <td>{{ site.group ? site.group.name : '/' }}</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import EditText from '../../../Helpers/Form/EditText'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      domain: '',
      tag: {},
      tags: ['pbn', 'money', 'dev', 'authority'],
      linkSites: []
    }
  },
  components: {
    eTxt: EditText
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.domain = this.$route.params.domain
    this.loadTag()
    this.loadSites()
    document.title = this.domain + ' :: Link Tag :: PBN360 by Aphex Media'
  },
  methods: {
    loadTag () {
      axios.get('/pbn/link-tag/' + this.domain)
        .then(r => {
          this.tag = r.data
        })
        .catch()
    },
    loadSites () {
      axios.get(`/pbn/link-tag/${this.domain}/pbns`)
        .then(r => {
          this.linkSites = r.data.data
        })
        .catch(e => {
          this.$toastr.error(e.response.data.msg, 'Load failed')
        })
    },
    updateProperty (val, prop) {
      let data = {}
      data[prop] = val
      axios.patch('/pbn/links/tag/' + this.domain, data)
        .then(r => {
          this.$toastr.success('Tag updated', 'Success')
        })
        .catch(e => {
          this.$toastr.error(e.response.data.msg, 'Error')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Tag.vue